import React from 'react';
import { Link } from 'react-router-dom';
import BasketImg from '../assets/img/basket.svg'

import '../scss/components/thanks.scss'
const Thanks = () => {
    const nameDeliver = ['Даниил', 'Андрей', 'Александр', 'Никита', 'Максим', 'Светлана', 'Александра', 'Алексей'];
const randomName = Math.floor(Math.random() * nameDeliver.length);
  return (
    <>
        <div className="wrapper-thanks">
            <div className="container-thanks">
                <h2>Спасибо!😊 <br /> Заказ успешно оплачен!🥳</h2>
                <img className='img-basket' src={BasketImg} alt="" />
        <span>Заказ готовится к сборке</span>
        <p>Его доставит курьер по имени <u><strong>{nameDeliver[randomName]}</strong></u> 😉 </p>  
        <Link to="/" className="button button--outline button--add go-back-btn thanks-button">
              <svg
                width="8"
                height="14"
                viewBox="0 0 8 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7 13L1 6.93015L6.86175 1"
                  stroke="#D3D3D3"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <span>Вернуться назад</span>
            </Link>
            </div>
            
        </div>
        
        </>
  )
}

export default Thanks